import Error from 'next/error'

// NOTES:
//
// - This page will be rendered as a static page, and takes precidence over
// _error.tsx. It will be rendered if any error occurs during Vercel severless
// function, i.e. getServerSideProps.
//
// - Vercel ignores _error.tsx for server-side errors, and if 500.tsx does not
// exist, Vercel will print an ugly "Serverless function has crashed" message,
// which we don't want.
//
// - _error.tsx will still be used for client-side errors in production mode
//
// - When rendering this component, @sentry/nextjs will automatically send the
// error to Sentry, no need to call `captureException` like _error does.
//
// - If a getServerSideProps returns an Axios 404 exception, then this 500.tsx
// component gets rendered by default. There does not seem to be anyway to make
// it render the 404.tsx component automaically in this situation, which would
// make more sense to the user. However, we can add a `try/catch` to each
// getServerSideProps function, and force it to return `statusCode: 404, to make
// it render 404.tsx
export default function ServerError() {
  return <Error statusCode={500} />
}
